/*
Copyright (C) 2009 - 2019 Broadleaf Commerce.

Licensed under the Broadleaf End User License Agreement (EULA),
Version 1.1 (the “Commercial License” located at
http://license.broadleafcommerce.org/commercial_license-1.1.txt).

Alternatively, the Commercial License may be replaced with a mutually
agreed upon license (the “Custom License”) between you and
Broadleaf Commerce. You may not use this file except in compliance
with the applicable license.
*/

import ImpersonateCustom from './ImpersonateCustom';
import CopyWhitelabel from 'app/view/components/actions/CopyWhitelabel/CopyWhitelabel';

export { default as SecondaryAction } from './SecondaryAction';
export default [
  {
    placement: 'SECONDARY',
    type: 'IMPERSONATE_CUSTOM',
    component: ImpersonateCustom
  },
  {
    placement: 'SECONDARY',
    type: 'IMPERSONATE_GUEST_CUSTOM',
    component: ImpersonateCustom
  },
  {
    placement: 'SECONDARY',
    type: 'COPY_WHITELABEL',
    component: CopyWhitelabel
  }
];

export {
  WHITE_LABEL_IMPERSONATE,
  DEFAULT_IMPERSONATE,
  DEALER_NETWORK_IMPERSONATE,
  isDealerNetworkResolverType,
  isDefaultResolverType,
  isWhiteLabelResolverType
} from './ImpersonateCustom';
